import React, { ReactElement } from 'react';
import { getGlobalProps } from 'utils/helpers/server/serverSideProps/global';
import { ServerSideInitProps } from 'types/types';
import { getPageProps } from 'utils/helpers/server/serverSideProps/ssrProps';
import { getPageNamespaces } from 'utils/helpers/server/serverSideProps/translations';
import RenewMembershipPage from 'components/pages/renewMembership/RenewMembershipPage';

type Props = Record<string, never>;

interface ServerSideProps {
    props?: Props;
}

const Page = (): ReactElement => <RenewMembershipPage />;

export const getServerSideProps = async ({
    req,
    res,
    query,
}: ServerSideInitProps): Promise<ServerSideProps> => {
    const { api } = await getGlobalProps(req, res, true);

    const props = await getPageProps<Props>({
        givenProps: {},
        res,
        req,
        api,
        query,
        loadUserData: true,
        translatePage: true,
        nameSpaces: getPageNamespaces('/renew-membership'),
    });

    return {
        props,
    };
};

export default Page;
